'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _serializer = require('./serializer');

var _serializer2 = _interopRequireDefault(_serializer);

var _eventBuilder = require('./eventBuilder');

var _eventBuilder2 = _interopRequireDefault(_eventBuilder);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EventQueue = function () {
  function EventQueue(client, eventEmitter) {
    _classCallCheck(this, EventQueue);

    this.leQueue = [];
    this.client = client;
    this.eventEmitter = eventEmitter;
    eventEmitter.on('eventd-enabled', this.sendQueuedEvents.bind(this));
    eventEmitter.on('event-pushed', this.shift.bind(this));
  }

  _createClass(EventQueue, [{
    key: 'sendQueuedEvents',
    value: function sendQueuedEvents() {
      while (this.isEmpty() === false) {
        this.shift();
      }
    }
  }, {
    key: 'push',
    value: function push(element) {
      this.leQueue.push(element);
      this.eventEmitter.emit('event-pushed');
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return !this.leQueue.length;
    }
  }, {
    key: 'shift',
    value: function shift() {
      if (this.isEmpty() || this.client.disabled) {
        return;
      }

      var value = this.leQueue.shift();
      var event = value.event,
          properties = value.properties;
      var clientName = this.client.clientName;
      var eventPayload = (0, _eventBuilder2.default)({
        name: event,
        customProperties: properties,
        clientName: clientName
      });
      var queryArgs = (0, _serializer2.default)(eventPayload);

      if (this.client && this.client.debugMode) {
        console.log('event: ' + event);
        console.log('properties: ' + JSON.stringify(properties));
        console.log('queryArgs: ' + queryArgs);
        return;
      }

      if (!this.client.eventUrl) {
        throw new Error('Event Url is not set.');
      }

      EventQueue.buildImage(this.client.eventUrl + '?' + queryArgs);
    }
  }, {
    key: 'contents',
    value: function contents() {
      return this.leQueue;
    }
  }, {
    key: 'length',
    get: function get() {
      return this.leQueue.length;
    }
  }], [{
    key: 'buildImage',
    value: function buildImage(src) {
      var image = new Image(0, 0);
      image.src = src;
      image.alt = '';
      image.style.display = 'flex'; // TODO: Check if this is necessary

      if (typeof document !== 'undefined') {
        document.body.appendChild(image);
      }

      return image;
    }
  }]);

  return EventQueue;
}();

exports.default = EventQueue;